  import { put, call } from "redux-saga/effects";
  import {ActionConstants, ApiConstants} from "../constants";
  import axios from "axios";

  export default function* createAccountSaga(data) {
    try {
      const result = yield call(createAccountApi, data.payload);

      if (result == null || result.status !== 1) {
        yield put({
          type: ActionConstants.CREATE_ACCOUNT_ACTION_FAILURE,
          payload: {
            result: result != null ? result.error : null,
          },
        });
      } else {
        yield put({
          type: ActionConstants.CREATE_ACCOUNT_ACTION_SUCCESS,
          payload: {
            result: result.data != null ? result.data : null,
            error: result.error != null ? result.error : null
          },
        });
      }
    } catch (e) {
      yield put({
        type: ActionConstants.CREATE_ACCOUNT_ACTION_FAILURE,
        payload: {
          result: e,
        },
      });
    }
  }

  const createAccountApi = params => {
    const url = ApiConstants.URI_FE + ApiConstants.API_CREATE_ACCOUNT;
    return axios.post(url, params).then(response => response.data);
  };
